<template>
  <oie-base-button
    css-classes="button--with-border button--green skulist__actions-right"
    :text="tStatic('cartAddSkuListToCart')"
    :disabled="products.length === 0"
    @click="addListToCart"></oie-base-button>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    products: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters(['enableGtm'])
  },
  methods: {
    addListToCart() {
      this.$store.dispatch('commerce/addListToCart', { rows: this.products }).then(() => {
        if (this.enableGtm) {
          const gtmObject = _.map(this.products, (product) => {
            return gtm.createGtmItem(
              product.itemId,
              product.displayName,
              product.purchasedToVehicle,
              product.purchasedOnCategory,
              this.formatPriceWithoutCurrency(product.priceExVat),
              product.quantity,
              this.gaCategory)
          })

          gtm.addToCart(gtmObject)
        }
      })
    }
  }
}
</script>

<style lang="scss">

  .skulist__actions-right {
    width: 100%;

    @include media(medium) {
      max-width: 24rem;
      width: 100%;
      margin-left: auto;
    }
  }

</style>
